import { BaseTemplate } from '@/components/template';
import { Layout, Paragraph, Title, Space } from '@/components/atoms';
import { Link } from 'react-router-dom';
import { PATH_MAIN } from '@/constants/constant';
import CarImg from '@images/bizcenter/img_ieguide.png';
import CarImgMobile from '@images/bizcenter/img_ieguide_m.png';

// TODO: 디자인 및 퍼블리싱
const BrowserOutdatedPage = () => {
  return (
    <BaseTemplate headerShow>
      <Layout className="mx-auto justify-center items-center my-16">
        <Space direction="vertical" className="browser-guide">
          <img src={CarImg} alt="자동차 이미지" className="img-guidecar pc" />
          <img src={CarImgMobile} alt="자동차 이미지" className="img-guidecar mobile" />
          <Title level={3}>핀카 비즈 센터 안내</Title>
          <Paragraph>
            현재 오래된 버전의 인터넷 브라우저를 사용 중입니다. <span>이 브라우저는 기술적 이유로 더이상 지원되지 않습니다.</span>
          </Paragraph>
          <Paragraph>핀카 비즈 센터를 이용하려면 다음과 같은 최신 버전의 브라우저를 사용하십시오.</Paragraph>
          <Paragraph className="link-list">
            <a href="https://www.google.com/chrome">Chrome</a>
            <a href="https://www.apple.com/safari">Safari</a>
            <a href="https://www.microsoft.com/en-us/edge">Edge</a>
            <a href="https://www.mozilla.org/en-US/firefox/new/?redirect_source=firefox-com">Firefox</a>
          </Paragraph>
          <Link to={PATH_MAIN} className="ant-btn ant-btn-primary button">
            시작페이지로 이동
          </Link>
        </Space>
      </Layout>
    </BaseTemplate>
  );
};

export default BrowserOutdatedPage;
